"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.gaps = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = require("react");
const stack_module_scss_1 = __importDefault(require("./stack.module.scss"));
exports.gaps = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs', 'xxs', 'none'];
const Stack = ({ as: Component = 'div', children, layout = 'vertical', gap = 'md', align, justify, className, width, flexWrap = false, }, ref) => ((0, jsx_runtime_1.jsx)(Component
//@ts-expect-error
, { 
    //@ts-expect-error
    ref: ref, className: (0, classnames_1.default)(stack_module_scss_1.default[layout], gap !== 'none' && stack_module_scss_1.default[gap], align && stack_module_scss_1.default[`align-${align}`], justify && stack_module_scss_1.default[`justify-${justify}`], width && stack_module_scss_1.default[`width-${width}`], flexWrap && stack_module_scss_1.default.flexWrap, className && className), children: children }));
exports.default = (0, react_1.forwardRef)(Stack);
